import { DateUtility } from '@mchs/web-core';

export const incrementDate = (date: Date, increment: number) => {
  const increasedDate = new Date(date.getTime() + increment * 86400000);
  return increasedDate;
};

export const incrementDateMonths = (date: Date, months: number): Date => {
  const returnDate = new Date(date);
  const month = returnDate.getMonth();
  returnDate.setMonth(returnDate.getMonth() + months);
  while (returnDate.getMonth() === month) {
    returnDate.setDate(returnDate.getDate() - 1);
  }

  return returnDate;
};

export const incrementDateYears = (date: Date, years: number): Date => {
  const returnDate = new Date(date);
  returnDate.setFullYear(returnDate.getFullYear() + years);

  return returnDate;
};

export const isMinor = (dateOfBirth: Date): boolean => {
  const currentDate = DateUtility.getDateWithoutTime(new Date());
  const workingDate = DateUtility.getDateWithoutTime(dateOfBirth);
  workingDate.setFullYear(workingDate.getFullYear() + 18);

  return workingDate > currentDate;
};
